import { KBLink, KBUrl } from '@upright/ui/common/upright/kb-urls';
import { friendlySource } from '@upright/ui/untidy/texts';
import { useEmployeeCount } from '@upright/ui/views/model-entity-views/company-view/context/use-employee-count';
import { format } from 'd3-format';

export function JobsText(props: { companyId?: string }) {
  if (!props.companyId) {
    return <NoEmployeeCountVersion />;
  }
  return <JobsTextWithCompany companyId={props.companyId} />;
}
const NoEmployeeCountVersion = () => {
  return (
    <>
      Upright considers people employed in all parts of the company's value chain. This means that for a particular
      company, some of its jobs will be attributed <em>to</em> other companies. Similarily, it will also be attributed
      jobs <em>from</em> other companies. For this reason, the number should not be expected to match companies'
      internal figures on people employed. (
      <KBLink href={KBUrl.ATTRIBUTION} target="_blank">
        Read more on attribution
      </KBLink>
    </>
  );
};

function JobsTextWithCompany(props: { companyId: string }) {
  const employeeCount = useEmployeeCount(props.companyId);
  if (!employeeCount) {
    return <NoEmployeeCountVersion />;
  }
  const formattedEmployeeCount = format(',')(employeeCount.count);

  return (
    <>
      <div>
        Upright considers people employed in all parts of the company's value chain. This means that for a particular
        company, some of its jobs will be attributed <em>to</em> other companies. Similarily, each company will also be
        attributed jobs <em>from</em> other companies. For this reason, the number should not be expected to match the
        amount of people employed by the company directly.
      </div>
      <div style={{ marginTop: '1.0em' }}>
        In <b>{employeeCount.year}</b>, the company had <b>{formattedEmployeeCount}</b> direct employees (source:{' '}
        {friendlySource(employeeCount).toLowerCase()}).
      </div>
      <div style={{ marginTop: '1.0em' }}>
        <KBLink href={KBUrl.ATTRIBUTION} target="blank">
          Read more on impact attribution
        </KBLink>
      </div>
    </>
  );
}
